// The Audimee symbol (public/images/logo-symbol.svg) drawn inline in the current text colour, for the one card that stands for the product rather than for a project: the page-level loading state, which has no project to show a cover of. Decorative; the card names the product in text.
export function AudimeeMark({ className }: { className: string }) {
  return (
    <svg
      aria-hidden
      viewBox="0 0 72 72"
      fill="currentColor"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72 36c0 19.882-16.118 36-36 36S0 55.882 0 36 16.118 0 36 0s36 16.118 36 36zm-48-8a4 4 0 0 1 8 0v16a4 4 0 0 1-8 0V28zm-12 2a4 4 0 0 0-4 4v3a4 4 0 0 0 8 0v-3a4 4 0 0 0-4-4zm28 2a4 4 0 0 1 8 0v8a4 4 0 0 1-8 0v-8zm20-1a4 4 0 0 0-4 4v1a4 4 0 0 0 8 0v-1a4 4 0 0 0-4-4z"
      />
    </svg>
  );
}
